import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class EvaluatorLeadSearchParams extends SearchParamsBase {
  initialize() {
    this.UseLeadDateRange = false;
    this.LeadDateFrom = dateTimeHelper.indefiniteDateValue();
    this.LeadDateTo = dateTimeHelper.indefiniteDateValue();
    this.UseRegistrationDateRange = false;
    this.RegistrationDateFrom = dateTimeHelper.indefiniteDateValue();
    this.RegistrationDateTo = dateTimeHelper.indefiniteDateValue();
    this.Form = null;
    this.Source = '';
    this.CreatedBy = '';
    this.ReferredBy = '';
    this.FilterByCreatedOn = false;
    this.CreatedOnFrom = null;
    this.CreatedOnTo = null;
    this.OfficeIds = [];
    this.CountryCodes = [];
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'EvaluatorLeadSearchParams';

  // Keep in sync with EvaluatorLeadConstants.AllowedSources on the backend.
  static getSourceOptions() {
    return [
      { label: 'All', value: '', disabled: false },
      { label: 'Meta', value: 'Meta', disabled: false },
      { label: 'Bamboo HR', value: 'Bamboo HR', disabled: false },
      { label: 'ESL', value: 'ESL', disabled: false },
      { label: 'Upwork', value: 'Upwork', disabled: false },
      { label: 'MSPA', value: 'MSPA', disabled: false },
      { label: 'BARE Referral (Manual)', value: 'BARE Referral', disabled: false },
      { label: 'Other', value: 'Other', disabled: false },
    ];
  }

  static fieldsInSearchBox = [
    { fieldName: 'UseLeadDateRange', label: 'Lead Date Range', className: 'col-3', type: InputTypesEnum.OnOff },
    {
      fieldName: 'LeadDateFrom',
      label: 'Lead Date Start',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseLeadDateRange,
    },
    {
      fieldName: 'LeadDateTo',
      label: 'Lead Date End',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseLeadDateRange,
    },
    {
      fieldName: 'UseRegistrationDateRange',
      label: 'Registration Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'RegistrationDateFrom',
      label: 'Registration Date Start',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseRegistrationDateRange,
    },
    {
      fieldName: 'RegistrationDateTo',
      label: 'Registration Date End',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseRegistrationDateRange,
    },
    { fieldName: 'Form', label: 'Form', className: 'col-3', type: InputTypesEnum.Text },
    {
      fieldName: 'Source',
      label: 'Source',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: EvaluatorLeadSearchParams.getSourceOptions(),
    },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-3', type: InputTypesEnum.UserSelect },
    { fieldName: 'ReferredBy', label: 'Referred By', className: 'col-3', type: InputTypesEnum.UserSelect },
    { fieldName: 'OfficeIds', label: 'FW Office', className: 'col-3', type: InputTypesEnum.OfficeOrGroupMultiSelect },
    { fieldName: 'CountryCodes', label: 'Country', className: 'col-3', type: InputTypesEnum.CountryCodeMultiChoice },
    {
      fieldName: 'FilterByCreatedOn',
      label: 'Filter by Created On',
      className: 'col-3',
      type: InputTypesEnum.Checkbox,
    },
    {
      fieldName: 'CreatedOnFrom',
      label: 'Created On Start',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.FilterByCreatedOn === true,
    },
    {
      fieldName: 'CreatedOnTo',
      label: 'Created On End',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.FilterByCreatedOn === true,
    },
  ];
}
